const selectStandardLabel: object = {
  position: "-top-1.5",
  after: {
    content: "after:content[' ']",
    display: "after:block",
    width: "after:w-full",
    position: "after:absolute",
    bottom: "after:-bottom-1.5",
    left: "left-0",
    borderWidth: "after:border-b-2",
    transition: "after:transition-transform after:duration-300",
  },
};

export default selectStandardLabel;
